import React from 'react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ProjectPreviewProps {
  imagePreview: string;
  embedCode: string;
  onCopyCode: () => void;
}

export const ProjectPreview = ({ imagePreview, embedCode, onCopyCode }: ProjectPreviewProps) => (
  <div className="space-y-6">
    {imagePreview && (
      <Card className="p-4 bg-black/50 backdrop-blur-sm border-gray-800">
        <h2 className="text-lg font-semibold mb-4 text-white">Image Preview</h2>
        <img
          src={imagePreview}
          alt="Preview"
          className="w-full h-48 object-cover rounded-md"
        />
      </Card>
    )}

    {embedCode && (
      <Card className="p-4 bg-black/50 backdrop-blur-sm border-gray-800">
        <h2 className="text-lg font-semibold mb-4 text-white">Embed Code</h2>
        <div className="bg-black/70 p-4 rounded-md">
          <code className="text-sm break-all text-gray-300">{embedCode}</code>
        </div>
        <Button
          onClick={onCopyCode}
          variant="outline"
          className="mt-4 w-full bg-gradient-primary text-white border-0 hover:opacity-90"
        >
          Copy Code
        </Button>
      </Card>
    )}
  </div>
);